import React from "react";
import * as yup from "yup";
import { Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useQueryClient } from "react-query";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import NotificationSuccess from "../notifications/agent-created-delete.notification";
import NotificationError from "../notifications/agent-error-delete.notification";
import { IUser } from "../../../../../../../services/microservice/admin/types/admin.types";
import PrimaryButton from "../../../../../../../components/buttons/PrimaryButton";
import Input from "../../../../../../../components/inputs/Input";
import { useChangeStatusAgent } from "../../../../../../../services/microservice/admin/agents/use-agents-admin";
import { useAgentsAdminContext } from "../../../../providers/agents-admin.provider";

interface IFormikValue {
  email: string;
  confirmEmail: string;
}
interface IProps {
  user: IUser | undefined;
}

const AgentDeleteForm = ({ user }: IProps) => {
  const { id } = useParams();
  const { mutateAsync: ChangeStatus, isLoading } = useChangeStatusAgent();
  const { sponsor } = useAgentsAdminContext();
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const initialValue: IFormikValue = {
    confirmEmail: user?.email || "",
    email: "",
  };

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .email("Debes ingresar un correo electrónico válido")
      .oneOf(
        [initialValue.confirmEmail],
        "El correo electrónico no coincide con el correo electrónico del agente",
      )
      .required(" Requerido"),
  });

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  const submit = () => {
    ChangeStatus(id)
      .then(() => {
        toast.success(<NotificationSuccess />);
        navigate(`/${sponsor}/admin/agents`);
      })
      .catch(() => toast.error(<NotificationError />))
      .finally(() => {
        queryClient.invalidateQueries("users/findOneUser");
      });
  };

  return (
    <div>
      <div className="mb-5">
        <Typography variant="body1" className="w-full">
          Para {user?.isActive ? "Inactivar" : "Activar"} el agente {user?.name}{" "}
          por favor escriba el correo electrónico del agente.
        </Typography>
      </div>
      <div className="w-full">
        <form onSubmit={handleSubmit(submit)}>
          <Controller
            name="email"
            control={control}
            render={({ field }) => (
              <Input
                {...field}
                classNameContainer="w-full mb-7"
                classNameInput="w-full"
                placeholder="Email"
                error={errors.email?.message}
                required
              />
            )}
          />
          <div className="flex w-full justify-center">
            <PrimaryButton
              title={user?.isActive ? "Inactivar" : "Activar"}
              className={
                "mt-5 rounded-3xl bg-buttonBlack px-5 py-1 text-sm font-normal text-whiteSoft"
              }
              loading={isLoading}
              type="submit"
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default AgentDeleteForm;
